<template>
  <div>
    <div v-if="this.$root.signedIn && this.$root.currentSession">
      <div id="app" style="background-color: #DFE0E2 !important">
        <!-- Navigation -->
        <b-navbar toggleable="md" class="sf-navbar" fixed="top">
          <b-navbar-toggle target="nav_collapse" />
          <b-navbar-brand to="/" class="sf-navbar">
            <b-img src="/static/thebrainlogo.png" class="navbar-img-logo" />
          </b-navbar-brand>
          <b-collapse is-nav id="nav_collapse" class="pl-3">
            <b-navbar-nav>
              <b-navbar-brand to="/scoring-events" class="sf-navbar">
                <b-img src="/static/Grow.png" class="navbar-img" />
                <br>
                Scoring Events
              </b-navbar-brand>
              <b-navbar-brand to="/wizard" class="sf-navbar">
                <b-img src="/static/Ruler.png" class="navbar-img" />
                <br>
                Import Survey Data
              </b-navbar-brand>
              <b-navbar-brand to="/new-scoring-event" class="sf-navbar">
                <b-img src="/static/Ask.png" class="navbar-img" />
                <br>Add Scoring Event
              </b-navbar-brand>
              <b-navbar-brand to="/quick-win-recommendation-search" class="sf-navbar">
                <b-img src="/static/Hammer.png" class="navbar-img" />
                <br>
                Quick Wins
              </b-navbar-brand>
              <b-navbar-brand to="/quick-win-recommendation-search?type=recommendations" class="sf-navbar">
                <b-img src="/static/Screwdriver.png" class="navbar-img" />
                <br>
                Recommendations
              </b-navbar-brand>
              <b-navbar-brand to="/gpc-sessions" class="sf-navbar">
                <b-img src="/static/Spanner.png" class="navbar-img" />
                <br>
                GPC Sessions
              </b-navbar-brand>
              <b-navbar-brand to="/smart-goals" class="sf-navbar">
                <b-img src="/static/pliers.png" class="navbar-img" />
                <br>
                SMART Goals
              </b-navbar-brand>
              <b-navbar-brand to="/industry-data" class="sf-navbar">
                <b-img src="/static/Think.png" class="navbar-img" />
                <br>
                Industry Data
              </b-navbar-brand>
              <b-navbar-nav class="ml-auto" right>
                <b-nav-item right>
                  <amplify-sign-out></amplify-sign-out>
                </b-nav-item>
              </b-navbar-nav>
            </b-navbar-nav>
          </b-collapse>



        </b-navbar>
        <!-- Page Content -->
        <br>
        <b-container class="mt-4 pt-2 pb-2 pl-2 pr-2">
          <b-row class="text-center" align-h="center">
            <router-view />
          </b-row>
          <b-row style="height: 200px">
            <b-img class="pl-2 pr-2 pb-2 auto-img" src="/static/squiggle-large.jpg" />
          </b-row>
        </b-container>
        <br>

      </div>
    </div>
    <div class="signin" v-else>
      <b>Welcome to The Brain</b><br><br>
      <button class="ms-signin-btn" @click="signInWithMicrosoft365" v-if="!this.$root.currentSession">
        <svg class="ms-logo" xmlns="http://w3.org" viewBox="0 0 23 23">
          <path fill="#f35325" d="M0 0h11v11H0z" />
          <path fill="#81bc06" d="M12 0h11v11H12z" />
          <path fill="#05a6f0" d="M0 12h11v11H0z" />
          <path fill="#ffba08" d="M12 12h11v11H12z" />
        </svg>
        <span class="ms-btn-text">Sign in with Microsoft</span>
      </button>
      <a v-if="this.$root.currentSession && !this.surveyMonkeySigningIn" :href="surveyMonkeyUrl" class='btn btn-primary surveymonkey mt-2 mb-2'>Survey
        Monkey Sign-In</a>
      <div v-if="this.surveyMonkeySigningIn" class="mt-2 mb-2">
        <br>
        <br>
        <b>Signing in to Survey Monkey...please wait...</b>
      </div>
      <div v-if="this.$root.currentSession" class="mt-2 mb-2">
        <br>
        <br>
        <b>Signed in to The Brain via Microsoft 365 as {{ this.$root.currentSession.getIdToken().payload.email }}</b>
      </div>
      <button v-if="this.$root.currentSession" :style="{ border: 'none', background: 'none'}">
        <amplify-sign-out></amplify-sign-out>
      </button>
    </div>
  </div>
</template>

<script>

import { onAuthUIStateChange } from '@aws-amplify/ui-components';
import { Auth } from 'aws-amplify';

import * as API from '@/services/API';

export default {
  name: 'App',
  data: () => ({
    surveyMonkeyUrl: `https://api.surveymonkey.com/oauth/authorize?response_type=code&client_id=${process.env.VUE_APP_SURVEY_MONKEY_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_BRAIN_URL}`,
    surveyMonkeySigningIn: false
  }),
  async created() {
    this.$root.currentSession = await Auth.currentSession();
    if (this.$route.query?.code?.length > 50) {
      this.surveyMonkeySigningIn = true;
      await API.authenticated(this.$route.query.code);
      this.$root.signedIn = true;
      this.surveyMonkeySigningIn = false;
      this.$router.push('/');
    }
  },
  beforeDestroy() {
    this.unsubscribeAuth();
  },
  methods: {
    async signInWithMicrosoft365() {
      try {
        await Auth.federatedSignIn();
      } catch (error) {
        console.error('Error federating', error);
      }
    }
  }
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.signin {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

/* little red asterick indicator */
label.required:after {
  content: " *";
  color: red;
}

div.required:after {
  content: " *";
  color: red;
}

.col-form-label {
  white-space: nowrap;
}

/* style the select dropdown */
/* this hides the doubled up arrows on the select elements 
   may cause issues in chrome
*/
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}

/* This ensures an invalid option in the select is gray as well - must have required field on select */
select.form-control.custom-select:invalid,
select.form-control.custom-select option[value=""]:first-child {
  color: gray;
  font-style: italic;
}

select.form-control.custom-select option:not(:first-child) {
  color: black;
  font-style: normal;
}

tr.c>td {
  vertical-align: middle;
}

.fa-file-download:hover {
  color: #dc3545;
}

amplify-sign-out {
  --amplify-primary-color: #EF2E24;
  --amplify-primary-contrast: #ffffff;
  --amplify-font-family: 'Avenir', Helvetica, Arial, sans-serif;
  --amplify-max-width: 200px;
}

.clickable {
  cursor: pointer;
}

.clickable>* {
  cursor: pointer;
}

.pad-top-1 {
  margin-top: 1em;
}

/* Chrome/Opera/Safari */
::-webkit-input-placeholder {
  color: gray;
  font-style: italic;
}

/* Firefox 19+ */
::-moz-placeholder {
  color: gray;
  font-style: italic;
}

/* IE 10+ */
:-ms-input-placeholder {
  color: gray;
  font-style: italic;
}

/* Firefox 18- */
:-moz-placeholder {
  color: gray;
  font-style: italic;
}

.btn-primary.surveymonkey {
  background-color: #00BF6F !important;
  border-color: #00BF6F !important;
}

.centergooglebutton {
  text-align: center;
  display: inline-block;
}

.container {
  background-color: #FFFFFF !important;
}

.auto-img {
  min-width: 100% !important;
  max-width: 100% !important;
  display: block;
  object-fit: contain;
}

.sf-navbar {
  background-color: #5F6062;
  color: #FFFFFF !important;
}

.navbar-img {
  height: 30px;
}

.navbar-img-logo {
  height: 50px;
}

.ms-signin-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #2f2f2f;
  /* Dark theme option (Use #ffffff with black text for light theme) */
  color: #ffffff;
  border: none;
  border-radius: 0px;
  /* Microsoft style typically uses sharp edges or very slight rounding */
  padding: 0 16px;
  height: 41px;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

/* Interaction states */
.ms-signin-btn:hover {
  background-color: #1f1f1f;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.ms-signin-btn:active {
  background-color: #000000;
}

/* Microsoft Logo Layout */
.ms-logo {
  width: 21px;
  height: 21px;
  margin-right: 12px;
  flex-shrink: 0;
}

/* Text layout */
.ms-btn-text {
  line-height: 1;
}
</style>
<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>
<style lang="css">
@import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue